// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeekHead-modulecorner__hPTwG CalendarGridWeekHeadCell-moduleCalendarGridWeekHeadCell__pX3uy";
export { _1 as "corner" }
